"use client";

import { useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useRouter } from 'next/navigation';
import { ToastContainer } from 'react-toastify';
import { useTheme } from '../../components/Common/themeContext';
import axios from "axios";
import { loginApi } from "@/app/utils/api";
import { showErrorToast } from "@/app/utils/toastConfig";
export default function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { themeColor } = useTheme();
    const router = useRouter();
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        try {
            //await new Promise(resolve => setTimeout(resolve, 2000));

            const response = await axios.post(
                `${loginApi.login}?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`
            );

            const data = response.data; // Axios parses JSON automatically

            if (response.status === 200 && response.data) {
                localStorage.setItem('userId', data.userId);
                localStorage.setItem('userName', data.userName);
                localStorage.setItem('firstName', data.firstName);
                localStorage.setItem('userType', data.userType);

                // Redirect to dashboard
                router.push('/pages/dashboard');
            }
            else if (response.status === 204) {
                showErrorToast("Invalid username or password");
            }
            else {
                showErrorToast('Login failed: User not found or inactive');
            }
        } catch (error: any) {
            console.error('Error during login:', error);
            showErrorToast('Something went wrong. Please try again.');
        }
        finally {
            setLoading(false); // Stop loading in all cases
        }
    };
    return (
        // <Box
        //     sx={{
        //         display: "flex",
        //         justifyContent: "center",
        //         alignItems: "center",
        //         height: "100vh",
        //         //backgroundImage: 'url("/Login.png")',
        //         backgroundSize: "cover",       // make image cover entire box
        //         backgroundPosition: "center",  // center the image
        //         backgroundRepeat: "no-repeat", // avoid repeating
        //         p: 2,
        //     }}
        // >
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                p: 2,
                bgcolor: themeColor,
                //bgcolor: "primary.main", // fallback color
                // background: (theme) =>
                //     `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            }}
        >
            <Paper
                elevation={12}
                sx={{
                    width: { xs: "90%", sm: "400px" },
                    p: 5,
                    borderRadius: 4,
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                    "&:before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "linear-gradient(135deg, rgba(255,255,255,0.05) 25%, transparent 25%)",
                        transform: "rotate(45deg)",
                        zIndex: 0,
                    },
                }}
            >
                <Box sx={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                    {/* Avatar */}
                    {/* <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
                        <LockOutlinedIcon />
                    </Avatar> */}
                    <Box
                        display="flex"
                        alignItems="center"
                        sx={{ cursor: 'pointer' }}
                    >
                        <img
                            src="/Logo.png"
                            alt="SATHYA"
                            style={{ width: '100%', height: 48, marginRight: 8 }}
                        />
                    </Box>
                    <Typography variant="h5" sx={{ mb: 3 }}>
                        Sign In
                    </Typography>

                    {/* Social Login Buttons
          <Box sx={{ width: "100%", mb: 2 }}>
            <Button fullWidth variant="outlined" startIcon={<GoogleIcon />} sx={{ mb: 1 }}>
              Sign in with Google
            </Button>
            <Button fullWidth variant="outlined" startIcon={<FacebookIcon />} sx={{ mb: 2 }}>
              Sign in with Facebook
            </Button>
          </Box>

          <Divider sx={{ width: "100%", mb: 2 }}>OR</Divider>
 */}
                    {/* Login Form */}
                    <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
                        <TextField
                            fullWidth
                            label="Username"  // changed
                            type="text"       // changed
                            value={username}  // changed
                            onChange={(e) => setUsername(e.target.value)} // changed
                            required
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            margin="normal"
                        />
                        {/* <Typography
              variant="body2"
              sx={{ textAlign: "right", mb: 1, cursor: "pointer", color: "primary.main" }}
            >
              Forgot password?
            </Typography> */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={loading}
                            sx={{ mt: 1, mb: 2, bgcolor: themeColor, "&:hover": { bgcolor: themeColor } }}
                        >
                            {loading ? (
                                <CircularProgress size={24} sx={{ color: "white", bgcolor: themeColor }} />
                            ) : (
                                "Sign In"
                            )}
                        </Button>
                    </Box>
                </Box>
                {/* Footer */}
                <div className="mt-8 text-center text-sm text-gray-600" style={{ position: 'relative', zIndex: 1 }}>
                    <span>
                        © {new Date().getFullYear()}{" "}
                        <a
                            href="https://www.sathya.store/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-red-600 font-bold hover:underline"
                        >
                            sathya.store
                        </a>
                        {" "}
                        All Rights Reserved
                    </span>
                </div>
                <div className="mt-1 flex justify-center items-center gap-2 text-xs text-gray-500">
                    <span>Powered By</span>

                    <div className="relative group">
                        <img
                            src="/Vivin.png"
                            alt="Vivin Logo"
                            className="w-10 h-10 cursor-pointer"
                        />

                        <span
                            className="absolute -top-8 left-1/2 -translate-x-1/2
            opacity-0 group-hover:opacity-100
            transition-opacity duration-300
            bg-black text-white text-xs px-2 py-1 rounded
            whitespace-nowrap"
                        >
                            Vivin
                        </span>
                    </div>
                    <span>| V 1.0.0</span>
                </div>
            </Paper>

            <ToastContainer />
        </Box>
    );
}
